import React from "react";
import { useNavigate } from "react-router-dom";

const WhatsappWalletSuccess = () => {
  const navigate = useNavigate();

  const goHome = () => {
    navigate("/payment/payment-options"); // navigate to home
  };

  return (
    <div className="min-h-screen flex justify-center items-center bg-green-50">
      <div className="bg-white p-8 rounded-xl shadow-lg text-center max-w-md">
        <h1 className="text-3xl font-bold text-green-600 mb-4">Payment Successful!</h1>
        <p className="text-gray-700 mb-6">
          Your wallet has been credited successfully.
        </p>
        <button
          onClick={goHome}
          className="bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition"
        >
          Go to Home
        </button>
      </div>
    </div>
  );
};

export default WhatsappWalletSuccess;
